export default {
  rowPerPage: 10,
  page: 1,
}
